<jv-hrms-ui-header
    #globalHeader
    *ngIf="!hideGlobalChrome"
    [attr.inert]="isLoggingOut ? '' : null"
    [attr.aria-busy]="isLoggingOut"
    [class.header-logo-clickable]="isHeaderLogoHovered"
    [loggedIn]="isPrivateArea"
    (click)="onHeaderClick($event)"
    (keydown)="onHeaderKeyDown($event)"
    (mousemove)="onHeaderPointerMove($event)"
    (mouseleave)="onHeaderPointerLeave()"
    (logoutClicked)="onSessionButtonClick()">
</jv-hrms-ui-header>

<jv-hrms-ui-close-session
    *ngIf="!hideGlobalChrome"
    [attr.inert]="isLoggingOut ? '' : null"
    [attr.aria-busy]="isLoggingOut"
    [open]="isCloseSessionDialogOpen"
    [heading]="'auth.logout.heading' | translate"
    [description]="'auth.logout.description' | translate"
    [confirmText]="'auth.logout.confirmText' | translate"
    [cancelText]="'auth.logout.cancelText' | translate"
    [closeButtonLabel]="'auth.logout.closeButtonLabel' | translate"
    (jvConfirm)="onCloseSessionConfirm()"
    (jvCancel)="onCloseSessionCancel()"
    (jvClose)="onCloseSessionDialogClose()">
</jv-hrms-ui-close-session>

<jv-page>
    <div [attr.inert]="isLoggingOut ? '' : null" [attr.aria-busy]="isLoggingOut">
        <router-outlet></router-outlet>
    </div>
</jv-page>

<app-footer
    *ngIf="!hideGlobalChrome"
    [attr.inert]="isLoggingOut ? '' : null"
    [attr.aria-busy]="isLoggingOut"
    [sections]="footerSections"
    [legalLinks]="footerLegalLinks"
    [socialLinks]="footerSocialLinks">
</app-footer>

<app-full-screen-loader
    [active]="isLoggingOut"
    [message]="'auth.logout.loading' | translate">
</app-full-screen-loader>

<small *ngIf="showApplicationVersion" class="application-version" [attr.aria-label]="'Application version ' + appVersion">
    v{{ appVersion }}
</small>
